import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Axios from 'axios';
import usePagination from '../../hooks/usePagination';

const API_URL = process.env.REACT_APP_API_URL;

const ViewSatheeStudents = ({ role, showAllEntities }) => {
    const [students, setStudents] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    
    // Filters
    const [filterState, setFilterState] = useState("");
    const [filterDistrict, setFilterDistrict] = useState("");
    const [filterSchool, setFilterSchool] = useState("");
    const [filterClass, setFilterClass] = useState("");

    const states = [
        "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat", "Haryana",
        "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
        "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana",
        "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal"
    ];

    useEffect(() => {
        fetchStudents();
    }, [showAllEntities, role]);

    const fetchStudents = async () => {
        try {
            const response = await Axios.get(`${API_URL}/sathee-students/all`, {
                headers: {
                    Authorization: localStorage.getItem('token')
                }
            });
            if (response.data.status === 'success') {
                setStudents(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching students:', error);
            toast.error('Failed to fetch students!');
        }
    };

    const handleDelete = async (studentId, studentName) => {
        if (window.confirm(`Are you sure you want to delete "${studentName}"?`)) {
            try {
                const response = await Axios.delete(`${API_URL}/sathee-students/${studentId}`, {
                    headers: {
                        Authorization: localStorage.getItem('token')
                    }
                });

                if (response.data.status === 'success') {
                    toast.success(response.data.message);
                    fetchStudents();
                } else {
                    toast.error(response.data.message);
                }
            } catch (error) {
                console.error('Error deleting student:', error);
                toast.error('Failed to delete student!');
            }
        }
    };

    const downloadExcel = (filtered = false) => {
        let url = `${API_URL}/sathee-students/download-excel`;
        if (filtered) {
            const params = new URLSearchParams();
            if (filterState) params.append('state', filterState);
            if (filterDistrict) params.append('district', filterDistrict);
            if (filterSchool) params.append('schoolName', filterSchool);
            if (filterClass) params.append('studentClass', filterClass);
            url += `?${params.toString()}`;
        }
        
        Axios.get(url, {
            headers: { Authorization: localStorage.getItem('token') },
            responseType: 'blob'
        }).then(response => {
            const href = window.URL.createObjectURL(response.data);
            const anchorElement = document.createElement('a');
            anchorElement.href = href;
            anchorElement.download = 'sathee_students.xlsx';
            document.body.appendChild(anchorElement);
            anchorElement.click();
            document.body.removeChild(anchorElement);
            window.URL.revokeObjectURL(href);
        }).catch(err => {
            console.error('Error downloading excel:', err);
            toast.error('Failed to download excel');
        });
    };

    const filteredStudents = students.filter(student => {
        const matchesSearch = 
            student.student_name?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
            student.school_name?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
            student.linked_school_name?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
            student.district?.toLowerCase()?.includes(searchQuery.toLowerCase());
            
        const matchesState = filterState ? student.state === filterState : true;
        const matchesDistrict = filterDistrict ? student.district?.toLowerCase()?.includes(filterDistrict.toLowerCase()) : true;
        const matchesSchool = filterSchool ? (student.school_name || student.linked_school_name)?.toLowerCase()?.includes(filterSchool.toLowerCase()) : true;
        const matchesClass = filterClass ? student.student_class === filterClass : true;
        
        return matchesSearch && matchesState && matchesDistrict && matchesSchool && matchesClass;
    });

    const {
        currentEntries,
        currentPage,
        totalPages,
        handlePrevPage,
        handleNextPage,
    } = usePagination(filteredStudents, 10);

    return (
        <main style={{ padding: '0px' }}>
            <div className="table-data" style={{ marginTop: '20px' }}>
                <div className="order">
                    <div className="head" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <h3><i className='bx bx-notepad' style={{color:'#6C5CE7'}}></i> Registered Students</h3>
                            <span style={{ backgroundColor: '#6C5CE7', color: 'white', padding: '3px 10px', borderRadius: '15px', fontSize: '12px', fontWeight: 'bold' }}>{filteredStudents.length}</span>
                        </div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <div className="search-container" style={{ position: 'relative' }}>
                                <i className="bx bx-search" style={{ position: 'absolute', left: '10px', top: '10px', color: '#999' }}></i>
                                <input
                                    type="text"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    placeholder="Search..."
                                    style={{ padding: '8px 10px 8px 30px', borderRadius: '20px', border: '1px solid #ddd', outline: 'none' }}
                                />
                            </div>
                            <button onClick={() => downloadExcel(false)} style={{ backgroundColor: '#10b981', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <i className='bx bxs-file-export'></i> Excel
                            </button>
                        </div>
                    </div>
                    
                    {/* Filters Section */}
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
                        <span style={{ fontSize: '14px', color: '#555', fontWeight: '600' }}><i className='bx bx-filter-alt'></i> FILTERS:</span>
                        
                        <select value={filterState} onChange={e => setFilterState(e.target.value)} style={filterInputStyle}>
                            <option value="">All States</option>
                            {states.map(s => <option key={s} value={s}>{s}</option>)}
                        </select>
                        
                        <input type="text" placeholder="District" value={filterDistrict} onChange={e => setFilterDistrict(e.target.value)} style={filterInputStyle} />
                        
                        <input type="text" placeholder="School Name" value={filterSchool} onChange={e => setFilterSchool(e.target.value)} style={filterInputStyle} />
                        
                        <select value={filterClass} onChange={e => setFilterClass(e.target.value)} style={filterInputStyle}>
                            <option value="">All Classes</option>
                            <option value="9">Class 9</option>
                            <option value="10">Class 10</option>
                            <option value="11">Class 11</option>
                            <option value="12">Class 12</option>
                            <option value="Passed">12th Passed</option>
                        </select>
                        
                        <button onClick={() => downloadExcel(true)} style={{ backgroundColor: '#10b981', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontSize: '13px' }}>
                            <i className='bx bxs-download'></i> Download Filtered Excel
                        </button>
                    </div>

                    <div className="artifacts-table-view" style={{ overflowX: 'auto' }}>
                        <table className="artifacts-table" style={{ width: '100%', borderCollapse: 'collapse', minWidth: '800px' }}>
                            <thead style={{ backgroundColor: '#f9f9f9', textAlign: 'left' }}>
                                <tr>
                                    <th style={thStyle}>ID</th>
                                    <th style={thStyle}>Student Name</th>
                                    <th style={thStyle}>School</th>
                                    <th style={thStyle}>Mobile Number</th>
                                    <th style={thStyle}>Email</th>
                                    <th style={thStyle}>Registration Date</th>
                                    <th style={{ ...thStyle, textAlign: 'center' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentEntries.length === 0 ? (
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: 'center', padding: '20px', color: '#888' }}>No students found matching your criteria.</td>
                                    </tr>
                                ) : (
                                    currentEntries.map((student, index) => (
                                        <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                                            <td style={tdStyle}>{student.id}</td>
                                            <td style={tdStyle}>
                                                <div style={{ fontWeight: '600', color: '#333' }}>{student.student_name}</div>
                                            </td>
                                            <td style={tdStyle}>{student.linked_school_name || student.school_name || 'N/A'}</td>
                                            <td style={tdStyle}>{student.mobile_number || 'N/A'}</td>
                                            <td style={tdStyle}>{student.email || 'N/A'}</td>
                                            <td style={tdStyle}>
                                                {student.created_at ? new Date(student.created_at).toLocaleDateString('en-US', {
                                                    year: 'numeric',
                                                    month: 'short',
                                                    day: 'numeric'
                                                }) : 'N/A'}
                                            </td>
                                            <td style={{ ...tdStyle, display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center' }}>
                                                <a
                                                    href="# "
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        localStorage.setItem('satheeStudentToEdit', JSON.stringify(student));
                                                        localStorage.setItem('activeOption', 'studentRegistration');
                                                        localStorage.setItem('activeSection', 'studentRegistration');
                                                        window.location.reload();
                                                    }}
                                                    style={{ color: '#fff', background: '#6C5CE7', padding: '5px 10px', borderRadius: '4px', textDecoration: 'none', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '3px' }}
                                                >
                                                    <i className='bx bx-edit'></i> Edit
                                                </a>
                                                <a
                                                    href="# "
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleDelete(student.id, student.student_name);
                                                    }}
                                                    style={{ color: '#fff', background: '#e74c3c', padding: '5px 10px', borderRadius: '4px', textDecoration: 'none', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '3px' }}
                                                >
                                                    <i className='bx bx-trash'></i> Delete
                                                </a>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="pagination" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' }}>
                        <button onClick={handlePrevPage} disabled={currentPage === 1} style={pageBtnStyle}>
                            Previous
                        </button>
                        <span style={{ fontSize: '14px', color: '#555' }}>
                            Page {currentPage} of {totalPages === 0 ? 1 : totalPages}
                        </span>
                        <button onClick={handleNextPage} disabled={currentPage === totalPages || totalPages === 0} style={pageBtnStyle}>
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </main>
    );
};

const filterInputStyle = {
    padding: '8px 12px',
    border: '1px solid #ddd',
    borderRadius: '20px',
    outline: 'none',
    fontSize: '13px',
    minWidth: '130px'
};

const thStyle = {
    padding: '12px 15px',
    color: '#666',
    fontWeight: '600',
    fontSize: '13px',
    textTransform: 'uppercase'
};

const tdStyle = {
    padding: '12px 15px',
    color: '#444',
    fontSize: '14px'
};

const pageBtnStyle = {
    padding: '6px 12px',
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: '4px',
    cursor: 'pointer',
    color: '#333'
};

export default ViewSatheeStudents;
